import { featuredReads } from "@/mocks/sections";
import type { FeaturedRead } from "../dataTypes";

interface DeepReadProps {
  onOpen: (read: FeaturedRead) => void;
}

export default function DeepRead({ onOpen }: DeepReadProps) {
  return (
    <section id="reads" className="scroll-mt-16 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div>
            <span className="inline-flex items-center gap-1.5 text-xs font-semibold tracking-[0.2em] text-accent-600">
              <i className="ri-article-line text-sm leading-none"></i>
              深读文章 LONGREAD
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              不只是吃瓜，更是读懂一个时代
            </h2>
            <p className="mt-3 max-w-2xl text-sm leading-6 text-foreground-600">
              我们把散落在各平台的热点现象，串成可读的深度内容：人设经济的逻辑、信息求证的技巧、围观文化的百年流变。
            </p>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-2">
          {featuredReads.map((read) => (
            <article
              key={read.id}
              className="group flex cursor-pointer flex-col overflow-hidden rounded-lg bg-background-50 ring-1 ring-background-200 transition-all hover:-translate-y-1 hover:ring-primary-300"
              onClick={() => onOpen(read)}
            >
              <div className="relative overflow-hidden">
                <img
                  src={read.image}
                  alt={read.title}
                  className="h-44 w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.03] sm:h-52"
                />
                <span className="absolute left-4 top-4 rounded-full bg-background-50/90 px-3 py-1 text-xs font-semibold text-accent-700 backdrop-blur">
                  {read.tag}
                </span>
              </div>

              <div className="flex flex-1 flex-col p-5">
                <h3 className="font-heading text-lg font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
                  {read.title}
                </h3>
                <p className="mt-2 line-clamp-2 flex-1 text-sm leading-6 text-foreground-600">
                  {read.excerpt}
                </p>
                <div className="mt-4 flex items-center justify-between border-t border-background-100 pt-3">
                  <span className="inline-flex items-center gap-1.5 text-xs text-foreground-500">
                    <i className="ri-time-line text-sm leading-none"></i>
                    阅读约 {read.minutes} 分钟
                  </span>
                  <span className="inline-flex items-center gap-1 text-sm font-medium text-primary-600">
                    开始阅读
                    <i className="ri-arrow-right-circle-line text-base leading-none transition-transform group-hover:translate-x-1"></i>
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}